import { render, staticRenderFns } from "./SparingInternal.vue?vue&type=template&id=5fb4d3a9&"
import script from "./SparingInternal.vue?vue&type=script&lang=js&"
export * from "./SparingInternal.vue?vue&type=script&lang=js&"
import style0 from "./SparingInternal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports